import { List } from 'immutable'
import React from 'react'
import { datalayerHandler } from '../../../../../utils/datalayer'
import { ImageBase, ImageOptions } from '../../../../../utils/image'
import { Link } from '../../../../../utils/link'
import { ParsedPhoneNumber } from '../../../../../utils/phoneNumber'
import { peopleBlockClasses } from '../../../../../utils/style'
import { convertReactNodeToString, getClassName, htmlDecode } from '../../../../../utils/utils'
import { useInView } from '../../../../hooks/useInView'
import { InviewOptions } from '../../blocksState'
import { SpecialistListLayout } from '../specialistsBlock/specialistsBlockLayout'

export type PeopleBlockProps = {
  index: number
  inview?: InviewOptions
  title: React.ReactNode
  link: {
    title: string
    url: string
  }
  people: List<{
    name: string
    image: ImageBase
    email?: string
    url?: string
    phoneNumber?: ParsedPhoneNumber
  }>
  imageOptions: ImageOptions
}

export type PeopleBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  footerClassName: string
  clickableClassName: string
  clickableWrapperClassName: string
  clickableLabelClassName: string
  clickableIconClassName: string
  iconId: string
}>

export const PeopleBlockLayout = (props: PeopleBlockProps) => {
  const { index, title, inview, people, imageOptions } = props
  const classes = peopleBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("PeopleBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        <header className={getClassName(classes, 'headerClassName', '')}>
          {title && <h2 className={getClassName(classes, 'titleClassName', 'mb-3')}>{title}</h2>}
        </header>

        <SpecialistListLayout
          specialists={people.toArray().map((person) => ({
            ...person,
            title: person.name,
            role:
              person.email || person.phoneNumber ? (
                <>
                  {person.email && <span>{person.email}</span>}
                  {person.phoneNumber && <span>{person.phoneNumber.formatted}</span>}
                </>
              ) : undefined,
            url: person.url || '',
          }))}
          imageOptions={imageOptions}
        />

        {props.link && props.link.title && (
          <footer className={getClassName(classes, 'footerClassName', '')}>
            <div className={getClassName(classes, 'clickableWrapperClassName', 'd-inline-block')}>
              <Link
                url={props.link.url}
                title={props.link.title}
                className={getClassName(classes, 'clickableClassName', 'btn btn-dark d-inline-flex')}
                additionalOnClick={() =>
                  datalayerHandler('people', undefined, undefined, {
                    kind: 'link',
                    title: convertReactNodeToString(title),
                    link: props.link.url,
                    label: props.link.title,
                  })
                }
              >
                <span className={getClassName(classes, 'clickableLabelClassName', '')}>
                  {htmlDecode(props.link.title)}
                </span>
              </Link>
            </div>
          </footer>
        )}
      </div>
    </section>
  )
}
